import { render, staticRenderFns } from "./phonenumber-valid-dialog.vue?vue&type=template&id=3300c22d&scoped=true&lang=pug&"
import script from "./phonenumber-valid-dialog.vue?vue&type=script&lang=ts&"
export * from "./phonenumber-valid-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3300c22d",
  null
  
)

export default component.exports